<template>
  <div class="page">
    <div class="m-tool-bar">
      <el-button
        type="iconButton"
        icon="h-icon-add"
        @click="handleAddDataView"
      >{{$t('management.dataView.add_data_view')}}</el-button>
    </div>
    <div
      class="m-main-container"
      v-loading="mainLoading"
      :element-loading-text="$t('common.loading_text')"
    >
      <template v-if="list.length>0">
        <data-view-card
          v-for="item in list"
          @refresh="_getDataViewList"
          :viewInfo="item"
          :key="item.id"
        ></data-view-card>
      </template>
      <div
        class="no-data"
        v-else
      >
        <div class="cell">
          <img src="../../../assets/images/no_data.png" /><br />
          <span>{{$t('common.no_data')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataViewCard from './data-view-card'
import configuration from 'api/config'
import api from '../../../api/api'
export default {
  data () {
    return {
      // 筛选值
      searchKey: '',
      // 看板数据
      list: [],
      mainLoading: false
    }
  },
  components: {
    dataViewCard
  },
  mounted () {
    this._getDataViewList()
  },
  methods: {
    // 清空筛选栏回调
    clearSearchKey () { },
    // 进入看板配置页
    handleAddDataView () {
      window.open(`${configuration.context}/management/data-view-configuration?branch=full`)
    },
    // 获取看板list
    _getDataViewList () {
      api.dataView.getDataViewList().then(res => {
        this.list = res.data || []
      }).catch(err => {
        this.$message.error(err.msg)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 18px 24px;
  .m-tool-bar {
    width: 100%;
    height: 32px;
    .u-search-ipt {
      float: right;
      width: 300px;
    }
  }
  .m-main-container {
    position: relative;
    width: 100%;
    height: calc(~"100% - 32px");
    box-sizing: border-box;
    padding-top: 24px;
    .no-data {
      display: table;
      width: 100%;
      height: 100%;
      .cell {
        display: table-cell;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        text-align: center;
        span {
          font-size: 12px;
          color: #999;
        }
      }
    }
  }
}
</style>
